import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {ClientContextProvider} from "./contexts/ClientContext"
import {JsonRpcContextProvider} from "./contexts/JsonRpcContext"
import {TransactionContextProvider} from "./contexts/TransactionContext"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ClientContextProvider>
        <JsonRpcContextProvider>
            <TransactionContextProvider>
                <App/>
            </TransactionContextProvider>
        </JsonRpcContextProvider>
    </ClientContextProvider>
);
